export default __webpack_public_path__ + "static/media/no_states.56f5ad16.png";